import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { TrackingState } from '../../enums/tracking-state.enum';
import { mapTrackerTitle } from '../../helpers/map-tracker-title.helper';
import { TrackerData } from './tracker-data';

@Component({
  selector: 'app-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor, DatePipe, TranslateModule],
})
export class TrackerComponent implements OnChanges {
  @Input() public state: TrackingState;
  @Input() public size: 'small' | 'large' = 'small';
  @Input() public date?: Date | string;
  public title: string;
  public readonly TrackingState = TrackingState;

  public completionMap = new Map<TrackingState, boolean>();

  public trackerSteps: TrackerData[] = [
    {
      state: TrackingState.InTransit,
      title: 'TRACKING.STATES.IN_TRANSIT',
    },
    {
      state: TrackingState.ArrivedInCountry,
      title: 'TRACKING.STATES.ARRIVED_IN_COUNTRY',
    },
    {
      state: TrackingState.ClearedCustoms,
      title: 'TRACKING.STATES.CLEARED_CUSTOMS',
    },
    {
      state: TrackingState.FinalDeliveryInProgress,
      title: 'TRACKING.STATES.FINAL_DELIVERY',
    },
    {
      state: TrackingState.Delivered,
      title: 'TRACKING.STATES.DELIVERED',
    },
  ];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.state) {
      this.title = mapTrackerTitle(this.state);
      this.mapCompletion();
    }
  }

  public mapCompletion(): void {
    // The below step needs to be added as we need to evaluate export complete as In Transit ito the tracking visual
    // Once we add export complete as its own tracking step visually,
    // then we can remove this and conditionally add the step in the above tracking steps
    // This is a bit convoluted as the system was not designed to handle titles that are not present as steps and vice versa
    // But will be be remedied as the new step is planned in the future deploy
    const currentState = this.state == TrackingState.ExportComplete ? TrackingState.InTransit : this.state;
    const { completionMap } = this.trackerSteps.reduce(
      (completionAcc, step) => ({
        reachedCompletedState: completionAcc.reachedCompletedState || step.state === currentState,
        completionMap: completionAcc.completionMap.set(step.state, !completionAcc.reachedCompletedState),
      }),
      { reachedCompletedState: false, completionMap: new Map<TrackingState, boolean>() }
    );
    this.completionMap = completionMap;
  }

  public isStateCompleted(state: TrackingState): boolean {
    return this.completionMap.get(state) || false;
  }
}
